export const BOAT_CONFIG = {
  maxRudderAngle: Math.PI / 4,
  rudderTurnRate: Math.PI / 30,
  turningMoment: 0.045,
  dragCoefficient: 0.985,
  maxSpeed: 15,
  noGoZoneHalfAngle: Math.PI / 4,
  mass: 200,
  momentOfInertia: 50,
  sailArea: 15,
  liftCoefficient: 1.2,
  maxHeelAngle: Math.PI / 6,
  heelDamping: 0.1,
  minSteerageSpeed: 0.3,
};

export const INITIAL_BOAT_STATE = {
  position: { x: 400, y: 400 },
  velocity: { x: 0, y: 0 },
  heading: 0,
  speed: 0,
  rudderAngle: 0,
  rudderInput: 0,
  sailAngle: 0,
  optimalSailAngle: 0,
  heelAngle: 0,
  pointOfSail: 'beamReach' as const,
  apparentWindAngle: Math.PI / 2,
  apparentWindSpeed: 10,
};

export const INITIAL_WIND_STATE = {
  direction: Math.PI,
  speed: 12,
  gustFactor: 1,
  targetDirection: Math.PI,
  shiftRate: 0.1,
};

export const INITIAL_GAME_STATE = {
  mode: 'free' as const,
  raceStatus: 'notStarted' as const,
  raceStartTime: null,
  raceElapsedTime: 0,
  currentBuoyIndex: 0,
  buoysRounded: [] as number[],
  isPaused: false,
  countdownValue: 3,
};
